__turbopack_context__.v({
  "wrapper": "imagePlaceholder-module-scss-module__2PcYGW__wrapper",
});
